<template>
  <v-app id="inspire" >
    <v-navigation-drawer v-model="drawer" fixed clipped app width="220" :hidden="hidden">
      <v-list dense>
        <div>&nbsp;</div> 
        <v-list-tile to="/home">
          <v-list-tile-action>
            <v-icon>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Home
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile to="/board">
          <v-list-tile-action>
            <v-icon>add</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Board
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile v-for="item in boards" :key="item.name" :to="item.href" >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ item.name }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <div>&nbsp;<br /><br /><br /></div> 
        <v-list-tile v-for="item in menuItems" :key="item.name" :to="item.href" >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ item.title }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar color="primary" dense fixed clipped-left app dark height="57px" :hidden="hidden" >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      
      <v-toolbar-title class="mr-5 align-center">
        <span class="title">Team&trade;</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-layout row align-center justify-end style="max-width: 650px">
        <v-btn flat icon dark>
          <img v-bind:src="user.image" style="width:28px; border-radius: 50%;"  />
        </v-btn>
        <v-btn flat icon dark to="/account/logout">
          <v-icon >exit_to_app</v-icon>
        </v-btn>
      </v-layout>
    </v-toolbar>
    <v-content :hidden="hidden">
        <v-layout justify-center align-center>
          <v-flex>
            <slot name="main">
              <router-view></router-view>
            </slot>
          </v-flex>
        </v-layout>
    </v-content>
    <slot name="other">
      <router-view></router-view>
    </slot>
  </v-app>
</template>

<script>
  import MemberRepo from "../services/MemberRepo.js";
  import HAL from "../helpers/HAL.js";
  import { mapGetters } from 'vuex';
  import GenericRepository from '../services/GenericRepository';

  export default {
    name: "NavigationMenu",
    data: () => ({
      drawer: true,
      boards: [],
      addBoard: null
    }),
    methods: {
      getIcon(val) {
          switch(val) {
            case 'help:board':
              return 'add';
            case 'help:member-list':
              return 'people';
            case 'help:companies':
              return 'business';
            case 'help:projects':
              return 'receipt';
            case 'help:sprint-list':
              return 'directions_walk';
            case 'help:cardtype-list':
              return 'style';
            case 'help:status-list':
              return 'offline_pin';
            default:
              return 'turned_in';
          }
      },
      loadMenu() {
         if(!this.menuItems || this.menuItems.length <= 0) {
           
            MemberRepo.getMemberInfo().then(function(response) {
                let links = response.data._links;
                
                //  this.$store.dispatch('ADD_MENU_ITEM', {
                //       href: '/home', 
                //       name: 'Dashboard',
                //       icon: 'home',
                //       title: 'Home'
                //   });
                for(var i in links) {
                    if(!i.startsWith('help:'))
                      continue;
                    if(i == 'help:board') {
                      this.addBoard = links[i];
                      continue;
                    }

                    if(links[i].title && links[i].title.startsWith('[GET]')) {
                        this.$store.dispatch('ADD_MENU_ITEM', {
                            href: '/' + i.replace('help:', ''), 
                            collection: links[i].href,
                            name: i,
                            icon: this.getIcon(i),
                            title: links[i].title.replace('[GET] ', '')
                        });
                    }
                }

                let userInfo = { 
                  email: response.data.email,
                  firstName: response.data.firstName,
                  image: response.data.image,
                  lastName: response.data.lastName,
                  role: response.data.role,
                  username: response.data.username,
                  memberId: response.data.memberId
                }
                this.$store.dispatch('USER_INFORMATION', userInfo);
            }.bind(this));
        }

        if(!this.boards || this.boards.length <= 0) {
          GenericRepository.getCollection('/api/boards').then(function (response) {
            if(response.data && response.data.status == 'Success') {
              let boards = HAL.getEmbededResources(response.data, "help:board");
              this.boards = [];
              for(let i in boards) {
                this.boards.push({ name: boards[i].name,  icon: this.getIcon("help:boards"), href: '/boards/' + boards[i].boardId })
              }
            }

          }.bind(this));
        }
      }
    },
    props: {
      source: String,
      hidden: Boolean
    },
    computed: {
      ...mapGetters([
        'menuItems',
        'authData',
        'user'
      ])
    },
    created() {
      if(this.authData.access_token != null) {
        this.loadMenu();
      }
    },
    watch:{
      $route () {
        if(this.$route.name == 'Dashboard' )
          this.loadMenu();
      }
    } 
  }
</script>